import PropTypes from "prop-types";
import React, { useState } from "react";

import { Alert, Button, Container,Col,  Row, Form } from "reactstrap";
import styles from "./Login.module.css"

import tccontrolLogo from "./img/tccontrolLogo.png"


// Redux
import { connect } from "react-redux";
import { withRouter, Link} from "react-router-dom";

// actions
import { loginUser } from "../../store/actions";  

function Login(props) {
    const [formData, setFormData] = useState({
        username: "",
        password: "",
      });
    
      const { username, password } = formData;
    
      const onChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
      };
    
      const onSubmit = (e) => {
        e.preventDefault();
        props.loginUser({ username, password }, props.history);
      };


  return (
    <Container fluid>

      <Row>

        <Col lg='6'>
        <div className={` d-flex flex-row  justify-content-center pt-5 ${styles["form-logo"]}`} >

         
          </div>


          <div className="text-center mb-5">
                <Link to="/login" className="auth-logo">
                  <img src={tccontrolLogo} alt="" height="150" className="auth-logo-dark" />
                </Link>
               
              </div>

          <Form className={`d-flex flex-column justify-content-center h-custom-2  pt-5 ${styles["form-pantalla"]}`} onSubmit={onSubmit}>

            <h4 className="fw-normal mb-3 ps-5 pb-3">Ingresa tus Datos para Continuar</h4>

            <input
             className={`${styles["form-control"]} mb-4 `} 
             type="text"        
             name="username"
             placeholder="Ingresa tu usuario"
             value={username}
             onChange={onChange}
             autoFocus
             required 
  
            />

            <input 
            className={`${styles["form-control"]} mb-4 `}
            type="password"
            name="password"
            placeholder="Ingresa tu contraseña"
            value={password}
            onChange={onChange}
            required

            />            

            {props.error &&
            typeof props.error.detail === "string" ? (
            <Alert color="danger">{props.error.detail}</Alert>
            ) : null}


            <Button 
            className={`mb-3 ${styles["form-button"]}`}
            color='primary' 
            size='lg' 
            type="submit"
            >
             <strong>Iniciar Sesión</strong> 
            </Button>
            <p className=" mb-5 pb-lg-3 ms-5"><a className="text-muted" href="#!"> ¿Olvidaste la contraseña?</a></p>
            <p className='ms-5 text-center'>¿No tienes cuenta? <a className="text-primary" href="/users/add_user2"> Crea una nueva aqui</a></p>
           


          </Form>

        </Col>


        <div className="col-6 d-lg-flex d-none h-100 my-auto pe-0 position-absolute top-0 end-0 text-center justify-content-center flex-column">
              <div
                className="position-relative bg-gradient-primary  h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
             >
           <img 
            src={tccontrolLogo}
            alt="" 
           
            />

              </div>
            </div>

      </Row>

    </Container>
  );
}

const mapStateToProps = (state) => {
    const { error, loading } = state.Login;
    return { error, loading };
  };
  
  Login.propTypes = {
    error: PropTypes.any,
    loading: PropTypes.bool,
    history: PropTypes.object,
    loginUser: PropTypes.func,
  };
  
  export default withRouter(connect(mapStateToProps, { loginUser })(Login));